import getText from "../../../../../utils/language.js"
import { GlobalContext } from "../../../../../utils/globalprovider.js";
import "./tabs.css"
import React from "react";

class ParamComboBox extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)
        this.state = 
        {
            value: this.props.value,
            defaultvalue: this.props.value,
        }

        if ("defaultvalue" in this.props)
        {
            this.state.defaultvalue = this.props.defaultvalue;
            this.state.checkdefault = true;
        }

        this.handleComboBox = this.handleComboBox.bind(this)



    }
    handleComboBox(e)
    {
        
        var newvalue = e.target.value;
        console.log("combox box new value ", newvalue)
        this.setState({value: newvalue});
        this.props.onchange(this.props.paramnumber, newvalue);
    }

    render()
    {
        const selectBox = (
        <select 
            className="tabsettingscomboboxtext"
            value={this.props.value} 
            onChange = {this.handleComboBox}
            >
            {this.props.list.map((item, index) => 
            (
            <option value={index}>
            {getText(item.cat,item.scat, this.context.language)}
            </option>
        ))}
        </select>
        );                

        const title = getText(this.props.text.cat, this.props.text.scat, this.context.language);

        
        var tcolor="white";
        var checkdefault = false;
        var defaultvalue = this.props.value;
        if (this.props.coid > 0)
        {
            if ("defaultvalue" in this.props)
            {
                defaultvalue = this.props.defaultvalue;
                checkdefault = true;
            }
        }

        if (checkdefault)
        {
            if (this.state.value != defaultvalue)
                tcolor="#FF9800";
        }


        return(
            <div className ="tabsettingslidertext">
                <label style={{color:tcolor}}>
                {title} &nbsp;
                </label>
                {selectBox}
                
           </div>
        )
    }
}

export default ParamComboBox
